import React from "react";
import PaginaPublica from "../PaginasPublicas/PaginaPublica";
import { imagenesPosesionSC } from "./imagenesPosesionSC";

function Revista() {
  return <PaginaPublica titulo="Posesion Santa Cruz" imagenes={imagenesPosesionSC} />;
}

export default Revista;